import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=b0461a24&scoped=true&"
import script from "./BaseSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=b0461a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0461a24",
  null
  
)

export default component.exports